<template>
  <Request/>
</template>
<script>
import Request from "../components/request/Request.vue";

export default {
  components:{
    Request
  }  
}
</script>
<style scoped>

</style>